<template>
  <div class="container-fluid">
    <purchases-delivery-form
      :loading="loading"
      :purchasesDeliveryData="purchasesDelivery"
      :formErrors="formErrors"
      @purchasesDeliveriesubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import defaultTaxes from "@/constants/defaultTaxes";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesDelivery from "../defaultPurchasesDelivery";
import PurchasesDeliveryForm from "../partials/PurchasesDeliveryForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PurchasesDeliveryForm,
  },

  mixins: [alertLeave],

  data() {
    const purchasesDelivery = cloneDeep(defaultPurchasesDelivery);
    purchasesDelivery.taxes = cloneDeep(defaultTaxes);
    if (this.$currentUserIsLevelOrganization()) {
      purchasesDelivery.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      purchasesDelivery: purchasesDelivery,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(purchasesDelivery) {
      this.loading = true;
      const purchasesDeliveryData = cloneDeep(purchasesDelivery);
      try {
        await this.$store.dispatch(
          "purchasesDeliveries/add",
          purchasesDeliveryData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_DELIVERIES.PURCHASES_DELIVERY_ADDED"),
        });
        const purchasesDelivery = await this.$store.getters[
          "purchasesDeliveries/purchasesDelivery"
        ];
        this.$emit("onViewPurchasesDelivery", purchasesDelivery, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
